/**
 * Centralized language configuration for Sanity schemas
 */

export const languages = [
  { title: 'English', value: 'en' },
  { title: 'Spanish', value: 'es' },
] as const

export const defaultLanguage = 'en'

export type Language = (typeof languages)[number]['value']

/**
 * Language field definition for use in schemas
 */
export const languageField = {
  name: 'language',
  title: 'Language',
  type: 'string' as const,
  options: {
    list: [...languages],
    layout: 'radio' as const,
  },
  initialValue: defaultLanguage,
  validation: (Rule: any) => Rule.required(),
}
